<template>
  <div>
    <v-container fluid>
      <v-layout>
        <h1>Keywords</h1>
        <v-spacer></v-spacer>
        <v-btn large color="primary" @click="addRule"
          ><v-icon>add</v-icon> Add AI Rule</v-btn
        >
      </v-layout>

      <transition-group name="list" tag="div">
        <div
          class="card-curvey rule list-item"
          v-if="rules.length"
          v-for="(rule, index) in rules"
          :key="index"
        >
          <rule :rule="rule" :blocks="blocks"></rule>
          <v-btn
            @click="deleteRule(rule)"
            class="delete-rule"
            fab
            small
            color="#666"
            ><v-icon color="white">delete_outline</v-icon></v-btn
          >
        </div>
      </transition-group>
    </v-container>
  </div>
</template>

<script>
import _ from "lodash";
import rule from "../components/ai/rules";
export default {
  components: {
    rule,
  },
  data() {
    return {
      rules: [],
      blocks: [],
    };
  },
  async mounted() {
    await this.getBotAIs();
    await this.getBlocks();
  },
  methods: {
    async getBotAIs() {
      this.$store.dispatch("setLoader", true);
      const response = await this.$http_bot.get(`/rules`);
      this.rules = response.data;
      this.$store.dispatch("setLoader", false);
    },
    async getBlocks() {
      this.$store.dispatch("setLoader", true);
      const response = await this.$http_bot.get("/blocks");
      this.blocks = response.data;
      this.$store.dispatch("setLoader", false);
    },
    async addRule() {
      this.$store.dispatch("setSavingStatus", true);
      this.$store.dispatch("setLoader", true);
      const rule = {
        bot_id: this.botId,
        replay: [{ type: "text", text: "", blocks: [], errorOrEmpty: 0 }],
        terms: [],
      };
      const response = await this.$http.post("/rules", rule);
      let ai = response.data;
      ai.terms = [];
      this.rules.unshift(ai);
    },
    async deleteRule(rule) {
      this.$store.dispatch("setLoader", true);
      await this.$http.delete(`/rules/${rule.id}`);

      let index = _.findIndex(this.rules, (o) => {
        return o.id === rule.id;
      });
      this.rules.splice(index, 1);
      this.$store.dispatch("setLoader", false);
    },
  },
  computed: {
    botId() {
      return this.$store.state.bot.botId;
    },
  },
};
</script>

<style>
.list-item-enter-active,
.list-item-leave-active {
  transition: opacity 0.3s, -webkit-transform 0.3s;
  transition: opacity 0.3s, transform 0.3s;
  transition: opacity 0.3s, transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform-origin: left center;
  transform-origin: left center;
}
.list-item-enter,
.list-item-leave-to {
  opacity: 0;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
}
.list-item-leave-active {
  position: absolute;
}
.list-item-move {
  transition: -webkit-transform 0.4s linear 0.3;
  transition: transform 0.4s linear 0.3;
  transition: transform 0.4s linear 0.3, -webkit-transform 0.4s linear 0.3;
}
</style>
